import { defineComponent as _defineComponent } from 'vue'
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { dateRangeToDateStrings } from '@/utils/dates';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import { LayoutSlot } from '@/views/dashboard/layout-grid';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LaserConsumption',
  props: {
    dateRange: null,
    deviceId: null,
    timeAxisSpan: null
  },
  setup(__props: any) {

const props = __props as {
  dateRange: [Date, Date];
  deviceId: string;
  timeAxisSpan: FilterTimeAxisSpanEnum;
};



const gridLayout: LayoutSlot[] = [
  { column: 0, row: 0, width: 8, height: 8 },
  { column: 8, row: 0, width: 4, height: 4 },
  { column: 8, row: 4, width: 4, height: 4 },
];

function getWidgetHelpPosition(
  wd: WidgetDefinition,
): 'is-bottom-left' | 'is-bottom-right' {
  if (wd.index === 0) {
    return 'is-bottom-right';
  }
  return 'is-bottom-left';
}

const consumptionTimelineWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareLaserConsumptionTimeline,
      props.deviceId!,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      props.timeAxisSpan,
    ),
);

const availableVsUsedTimesWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareLaserConsumptionAvailableVsUsedTimeline,
      props.deviceId!,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      props.timeAxisSpan,
    ),
);

const powerUtilizationTimesWidgetDefinition = computed<WidgetDefinition>(
  () =>
    new WidgetDefinition(
      WidgetEnum.CareLaserConsumptionPowerUtilizationTimeline,
      props.deviceId!,
      dateRangeToDateStrings(props.dateRange),
      [],
      undefined,
      props.timeAxisSpan,
    ),
);

const widgetDefinitions = computed<WidgetDefinition[]>(() =>
  [
    consumptionTimelineWidgetDefinition.value,
    availableVsUsedTimesWidgetDefinition.value,
    powerUtilizationTimesWidgetDefinition.value,
  ].map((wd, index) => wd.withIndex(index)),
);

return { __sfc: true,props, gridLayout, getWidgetHelpPosition, consumptionTimelineWidgetDefinition, availableVsUsedTimesWidgetDefinition, powerUtilizationTimesWidgetDefinition, widgetDefinitions, WidgetContainer, LayoutGrid }
}

})